module.exports = __webpack_public_path__ + "img/tab-purification-selected.7f6a6515.png";